<template>
    <component
        :is="tag"
        :class="[
            'NavTab',
            active && 'NavTab--active',
            size !== '' && `NavTab--${size}`,
            display && 'NavTab--display'
        ]"
        role="navigation"
        :disabled="disabled"
        @click="$emit('navigate', to)"
    >
        <!-- @slot Can be used instead of the `label` prop -->
        <slot>{{ label }}</slot>
    </component>
</template>
<script>

export default {
    name: 'RPNavTab',
    props: {
        tag: {
            type: String,
            default: 'button',
        },
        size: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        /**
         * An object with a `name` property matching a route name
         */
        to: {
            type: Object,
            default: () => ({name: ''}),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Whether this is the currently active menu item in a list.
         */
        activeTab: {
            type: String,
            default: 'default',
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        display: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        active(){
            return !this.disabled
                    && (this.activeTab === this.to.name
                        || this.isActive);
        },
    },
};
</script>
<style lang="scss">
    .NavTab {
        background: transparent;
        padding: 0.5rem;
        font-size: 1rem;
        border-radius: 4px;
        border-width: 0;
        display: flex;
        white-space: nowrap;
        color: $text-grey;
        margin: 4px;

        &--sm {
            font-size: 0.875rem;
            height: 1.5em;
        }

        &--lg {
            padding: 0.5rem 1rem;
        }
        &:hover{
            background: $grey-50;
        }
        &:active,
        &--active {
            color: $text-link;
            background: $primary-50;
        }
        &:focus {
            outline: none;
            box-shadow: 0 0 4px $highlight-blue;
            overflow: visible;
        }
        &:disabled {
            color: $grey;
            color: $grey-100;
            background: $grey-50;
        }


        &--display {
            color: $text-link;
            background: $primary-50;
            &:hover{
                background: $primary-50;
            }
            &:focus {
                outline: none;
                box-shadow: none;
            }
        }
    }
</style>

<docs>
The `RPNavTab` component is generally used within navbars such as `RPSidebar`, `RPTopNav`, and `RPTopbar`.

Basic example:
```vue
<RPNavTab
    :to="{name: 'test-route'}"
    :activeTab="myValString"
    @navigate="n => myValString = myValString === '' ? n.name : ''">My Label</RPNavTab>
<br>
<RPNavTab :isActive="true">Active Prop</RPNavTab>
<br>
<RPNavTab :to="{name: 'ParentRoute'}" :activeTab="'ParentRoute'" label="Route Match"></RPNavTab>
<br>
<RPNavTab :disabled="true">Disabled</RPNavTab>
```
</docs>
